module.exports = __webpack_public_path__ + "img/tip_fpe_2.76f82ce7.png";